"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPORT_METRICS_LIMIT = void 0;
var REPORT_METRICS_LIMIT = exports.REPORT_METRICS_LIMIT = 100;